/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Node } from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';
import React from 'react';
import ClubPlusBadge from './club-plus-badge';
import { VsiCustomBadges } from './vsi-custom-badges';
import { RichText } from '@msdyn365-commerce/core';

export interface IMobileProductHeaderProps {
    // Product data
    productData: any;
    productTitle: string;
    // Context
    context: Msdyn365.ICoreContext;
    // Loading state
    isLoading: boolean;
    isComingSoonProduct: boolean;
    // Availability
    isProductAvailableCNC: boolean | undefined;
    isProductAvailableEcom: boolean;
    isISO: boolean;
    // Price
    priceComponent: React.ReactNode;
    // Club Plus
    displayClubPlusInfo: boolean;
    onToggleClubPlus: () => void;
    priceTooltipText?: RichText;
    clubPlusPrice: string | number | undefined;
    checkUserLoyalty: boolean | undefined;
    checkUserDiscounts: boolean | undefined;
}

const MobileProductHeader: React.FC<IMobileProductHeaderProps> = ({
    productData,
    productTitle,
    context,
    isLoading,
    isComingSoonProduct,
    isProductAvailableCNC,
    isProductAvailableEcom,
    isISO,
    priceComponent,
    displayClubPlusInfo,
    onToggleClubPlus,
    priceTooltipText,
    clubPlusPrice,
    checkUserLoyalty,
    checkUserDiscounts
}) => {
    return (
        <div className='ms-buybox__content mobile'>
            {/* Custom Badges */}
            {!isLoading && !isComingSoonProduct && (
                <VsiCustomBadges
                    productData={productData}
                    context={context}
                    isProductAvailableCNC={isProductAvailableCNC}
                    isProductAvailableEcom={isProductAvailableEcom}
                    isISO={isISO}
                    isComingSoon={isComingSoonProduct}
                    mode='text'
                />
            )}

            {/* Product Title */}
            <Node className='ms-buybox__product-title' tag='h1'>
                {productTitle}
            </Node>

            {/* Price and Club Plus Badge */}
            <div className='product-badge-pdp-container'>
                {priceComponent}
                <ClubPlusBadge
                    displayClubPlusInfo={displayClubPlusInfo}
                    onToggleClubPlus={onToggleClubPlus}
                    priceTooltipText={priceTooltipText}
                    clubPlusPrice={clubPlusPrice}
                    checkUserLoyalty={checkUserLoyalty}
                    checkUserDiscounts={checkUserDiscounts}
                />
            </div>
        </div>
    );
};

export default MobileProductHeader;
